<template>
  <!-- Funnel漏斗图，连接用户tab里面连接用户分布与行业均值展示-->
  <div :id="chartInfo.nodeId"></div>
</template>

<script>

export default {
  name: "FunnelChart",
  props:["chartInfo"],
  data(){
    return {
    }
  },
  computed:{
    
  },
  methods:{
    funnelChart(chartInfo){
      this.$echarts.dispose(document.getElementById(chartInfo.nodeId));
      var myChart = this.$echarts.init(document.getElementById(chartInfo.nodeId));
      myChart.setOption({
        tooltip: {
            show: false,
            trigger: 'none'
        },
        legend: {
            itemWidth: 8,
            itemHeight: 8,
            data: [{
                name:'达人连接',
                icon: 'circle',
                itemStyle:{
                    color:'#4e99de',
                    borderWidth:0
                }
            }, {
                name:'行业均值',
                icon: 'circle',
                itemStyle:{
                    color:'#FF5C00',
                    borderWidth:0
                }
            }],
            selectedMode: false,
            left: 0
        },
        series: [
            {
                name: '达人连接',
                type: 'funnel',
                orient: 'horizontal',
                gap: 5,
                width: '100%',
                left: 0,
                top: '10%',
                label: {
                    formatter: '{b}Expected\n1111',
                    position: 'leftBottom'
                },
                labelLine: {
                    length: 1000,
                    lineStyle: {
                        width: 1,
                        type: [5, 8],
                        color: '#ccc'
                    }
                },
                itemStyle: {
                    color: '#4e99de'
                },
                sort: 'none',
                data: chartInfo.data[0]
            },
            {
                name: '行业均值',
                type: 'funnel',
                orient: 'horizontal',
                width: '100%',
                gap: 5,
                left: 0,
                top: '10%',
                label: {
                    show: false
                },
                labelLine: {
                    show: false
                },
                itemStyle: {
                    color: 'transparent',
                    opacity: 0.8,
                    borderColor: '#FF5C00',
                    borderWidth: 1
                },
                emphasis: {
                    show: false
                },
                sort: 'none',
                data: chartInfo.data[1],
                z: 100
            }
        ]})    
    }
  },
  components:{
   
  },
  watch:{
    
  },
  mounted() {
    this.funnelChart(this.chartInfo)
  }
}
</script>

<style scoped>
  

</style>